import React from 'react';

const InputField = ({ label, name, value, onChange, type = 'text', placeholder, isDisable, maxlength = false, rows = 4,min }) => {
    return (
        <div className="w-full mb-4">
            <label
                htmlFor={name}
                className="block mb-1 text-sm font-medium text-gray-700"
            >
                {label}
            </label>
            {type === 'textarea' ? (
                <textarea
                    name={name}
                    id={name}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    rows={rows}
                    disabled={isDisable}
                    className="w-full px-3 py-2.5 border border-[#D8D8D8] rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
            ) : (
                <input
                    type={type}
                    name={name}
                    id={name}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    maxlength={maxlength ? maxlength : 9999}
                    disabled={isDisable}
                    className="w-full px-3 py-2.5 border border-[#D8D8D8] rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    min={min}
                />
            )}
        </div>
    );
};

export default InputField;
